import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Link from '../link/link';
import DiningData from '../dining-data/dining-data';

import styles from '../content-teaser/content-teaser.module.scss';

export const DiningTeaser = ({
  data,
  image,
  distance,
  experience,
  cuisine,
}) => {
  const path = data?.path?.alias;
  const title = data?.title;
  const summary = data?.body?.summary;
  const venueTitle = data?.relationships?.field_venue?.title;

  if (!path) {
    return (
      <>
        {image && image.contentTeaser ? (
          <Img
            alt={data?.field_image?.alt || ''}
            className={styles.img}
            sizes={image.contentTeaser}
          />
        ) : image ? (
          <img
            alt={data?.field_image?.alt || ''}
            className={styles.img}
            src={image}
          />
        ) : null}

        <div className={styles.diningContent}>
          <h2 className={styles.title}>{title}</h2>

          {venueTitle && (
            <p className={styles.venue}>{venueTitle}</p>
          )}

          {(distance || experience || cuisine) && (
            <DiningData
              distance={distance}
              experience={experience}
              cuisine={cuisine}
            />
          )}
        </div>
      </>
    );
  }

  return (
    <Link
      to={path}
      className={styles.diningCardLink}
      aria-label={`View dining details for ${title}`}
    >
      {image && image.contentTeaser ? (
        <Img
          alt=""
          className={styles.img}
          sizes={image.contentTeaser}
        />
      ) : image ? (
        <img
          alt=""
          className={styles.img}
          src={image}
        />
      ) : null}

      <div className={styles.diningContent}>
        <h2 className={styles.title}>{title}</h2>

        {venueTitle && (
          <p className={styles.venue}>{venueTitle}</p>
        )}

        {summary && <p className={styles.body}>{summary}</p>}

        {(distance || experience || cuisine) && (
          <DiningData
            distance={distance}
            experience={experience}
            cuisine={cuisine}
          />
        )}
      </div>
    </Link>
  );
};

DiningTeaser.propTypes = {
  data: PropTypes.object.isRequired,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  distance: PropTypes.string,
  experience: PropTypes.string,
  cuisine: PropTypes.string,
};

export default DiningTeaser;